import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

import HeroPanel from "@/components/HeroPanel";
import usePageMeta from "@/hooks/usePageMeta";
import { useContent } from "@/hooks/useContent";

const Offers = () => {
    const { data: leftData } = useContent("hero_left");
    const { data: rightData } = useContent("hero_right");

    const left = leftData?.data || {};
    const right = rightData?.data || {};

    usePageMeta({
        title: "Offres & promotions — Atelier AX",
        description: "Offres du moment Atelier AX : protections hydrogel, coques personnalisées et promotions accessoires mobiles au Maroc.",
        path: "/offres",
    });

    return (
        <div className="min-h-screen bg-[#FBFBFD] text-neutral-900 antialiased overflow-x-hidden">
            <main className="relative max-w-[1320px] mx-auto px-6 md:px-10 py-10 md:py-16">
                <nav aria-label="Fil d'Ariane" className="mb-8 flex items-center gap-2 text-[13px] text-neutral-500">
                    <Link to="/" className="hover:text-black transition-colors inline-flex items-center gap-1.5">
                        <ArrowLeft className="w-3.5 h-3.5" />
                        Accueil
                    </Link>
                    <span aria-hidden="true">/</span>
                    <span className="text-neutral-800">Offres</span>
                </nav>

                <div className="mb-10 md:mb-12">
                    <p className="dp-eyebrow mb-4 flex items-center gap-2">
                        <span className="w-1.5 h-1.5 rounded-full bg-[#d4af37]" />
                        Offres du moment
                    </p>
                    <h1 className="font-display text-4xl md:text-5xl font-semibold tracking-tight">
                        Nos offres
                    </h1>
                    <p className="mt-3 text-[15px] md:text-base text-neutral-500 max-w-2xl">
                        Promotions et services spéciaux Atelier AX : protection hydrogel et
                        personnalisation de coques, mis à jour régulièrement.
                    </p>
                </div>

                <div className="grid lg:grid-cols-2 gap-5 md:gap-6 items-stretch">
                    <HeroPanel
                        title={left.title || "حماية هيدروجيل لجميع شاشاتك"}
                        subtitle={
                            left.subtitle ||
                            "حماية شفافة ضد الخدوش والصدمات للهواتف، الساعات، شاشات السيارة والحواسيب."
                        }
                        image={left.image}
                        price={left.price}
                        devices={left.devices || []}
                        features={left.features || []}
                        delay={0.05}
                    />
                    <HeroPanel
                        title={right.title || "غلاف خلفي بصورتك أو شعارك"}
                        subtitle={
                            right.subtitle ||
                            "طباعة عالية الجودة على فيلم خلفي لإعطاء هاتفك مظهراً فريداً."
                        }
                        image={right.image}
                        price={right.price}
                        devices={right.devices || []}
                        features={right.features || []}
                        examples={right.examples || []}
                        delay={0.2}
                    />
                </div>
            </main>
        </div>
    );
};

export default Offers;
